"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardMerkleTree = void 0;
var standard_1 = require("./standard");
Object.defineProperty(exports, "StandardMerkleTree", { enumerable: true, get: function () { return standard_1.StandardMerkleTree; } });
//# sourceMappingURL=index.js.map